class Theming {
  #currentTheme;
  #tokens;

  useTheme(theme) {
    this.#currentTheme = theme;
    this.#tokens = {
      ...this.#currentTheme.config.palette,
      ...this.#currentTheme.config.aliases,
      ...this.#currentTheme.config.tokens
    };
  }

  getToken(token, path = [], tokens = this.#tokens) {
    if (!token) { return null; }

    if (this.#isString(tokens[token])) {
      path.push(token);
      return { name: path.join('-'), path, value: tokens[token] };
    }

    if (this.#isString(tokens[token]?.default)) {
      path.push(token, 'default');
      return { name: path.join('-'), path, value: tokens[token].default };
    }

    const keys = token.split('-');

    for (let index in keys) {
      const [key, tokenTailings] = this.#splitArrayAt(keys, index);

      if (!Object.keys(tokens).includes(key)) { continue; }

      path.push(key);
      return this.getToken(tokenTailings, path, tokens[key]);
    }

    return null;
  }

  getTokenVariant(token, variant) {
    const originalToken = this.getToken(token);
    if (originalToken === null) { return null; }

    const newToken = originalToken.path.slice(0, -1);
    newToken.push(variant);

    return this.getToken(newToken.join('-'));
  }

  generateToken(token, prefixName) {
    const prefix = prefixName ? `${prefixName}-` : '';
    const prefixedToken = `--${prefix}${token}`;
    const prefixedTokenWithDefault = `${prefixedToken}-default`;

    if (this.isValidToken(prefixedToken)) {
      return prefixedToken;
    }

    if (this.isValidToken(prefixedTokenWithDefault)) {
      return prefixedTokenWithDefault;
    }

    return null;
  }

  isValidToken(token) {
    return Boolean(getComputedStyle(document.documentElement).getPropertyValue(token));
  }

  #splitArrayAt(input, index) {
    const endIndex = !index ? undefined : -index;
    const start = input.slice(0, endIndex).join('-');
    const end = input.slice(input.length - index).join('-');

    return [start, end];
  }

  #isString(value) {
    return typeof value === 'string';
  }
}

export const theming = new Theming();
